import useReactRouter from 'use-react-router';

/**
 * Hook per ottenere la sezione corrente.
 */
export function useRouterCurrent() {
  const { location } = useReactRouter();
  const mainPath = location.pathname.split('/')[2];
  const secondaryPath = location.pathname.split('/')[3];
  const selectedKeys = secondaryPath
    ? [mainPath, mainPath + '/' + secondaryPath]
    : [mainPath];
  return selectedKeys;
}
